var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "div",
        { staticClass: "filter-container-content" },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "search-form",
              attrs: {
                model: _vm.searchForm,
                rules: _vm.searchFormRules,
                "label-position": "top",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom reqired",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.POR") + ":",
                            prop: "pol",
                          },
                        },
                        [
                          _c("gl-port", {
                            attrs: { placeholder: "" },
                            on: { change: _vm.polChange },
                            model: {
                              value: _vm.searchForm.pol,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "pol", $$v)
                              },
                              expression: "searchForm.pol",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom reqired",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.DEL") + ":",
                            prop: "pod",
                          },
                        },
                        [
                          _c("gl-port", {
                            attrs: { placeholder: "" },
                            on: { change: _vm.podChange },
                            model: {
                              value: _vm.searchForm.pod,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "pod", $$v)
                              },
                              expression: "searchForm.pod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "30px" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "0" },
                            model: {
                              value: _vm.searchForm.tsFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "tsFlag", $$v)
                              },
                              expression: "searchForm.tsFlag",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("booking.bookingJapan.radioDirect"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.searchForm.tsFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "tsFlag", $$v)
                              },
                              expression: "searchForm.tsFlag",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("booking.bookingJapan.radioTS"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom reqired",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.POLETD") + ":",
                            prop: "etdStr",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "",
                            },
                            model: {
                              value: _vm.searchForm.etdStr,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "etdStr", $$v)
                              },
                              expression: "searchForm.etdStr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("booking.bookingJapan.PODETA") + ":",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "",
                            },
                            model: {
                              value: _vm.searchForm.etaStr,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "etaStr", $$v)
                              },
                              expression: "searchForm.etaStr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchFormData()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("booking.bookingJapan.searchButton")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            on: {
                              click: function ($event) {
                                return _vm.resetForm()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("booking.bookingJapan.resetButton")
                              ) + "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-container-content",
          style: {
            backgroundColor: !_vm.showMainType ? "rgba(233,238,244,1)" : "#fff",
          },
        },
        [
          _c("div", [
            !_vm.showMainType
              ? _c("div", { staticClass: "info-content" }, [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("booking.bookingJapan.UsageMethod")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "info-texts",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("booking.bookingJapan.UsageMethodText1")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-texts" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("booking.bookingJapan.UsageMethodText2")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-second-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("booking.bookingJapan.ShippingScheduleInquiry")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "info-texts",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "booking.bookingJapan.ShippingScheduleInquiryText1"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-texts" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "booking.bookingJapan.ShippingScheduleInquiryText2"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-second-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("booking.bookingJapan.Results")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "info-texts",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("booking.bookingJapan.ResultsText")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-second-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("booking.bookingJapan.Booking")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "info-texts",
                      staticStyle: { "margin-top": "10px" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("booking.bookingJapan.BookingText1")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-texts" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("booking.bookingJapan.BookingText2")) +
                        "\n        "
                    ),
                  ]),
                ])
              : _c("div", [
                  _c("div", { staticClass: "table-main-content" }, [
                    _c("div", { staticClass: "table-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("booking.bookingJapan.Scheduleresults")
                          ) +
                          " " +
                          _vm._s(_vm.searchForm.pol) +
                          " -> " +
                          _vm._s(_vm.searchForm.pod) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "searchFormRef",
                            attrs: {
                              model: _vm.searchForm,
                              "label-position": "top",
                              "label-width": "90px",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 14 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: { type: "warning" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getBookingDetail()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "booking.bookingJapan.BookingButton"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { staticClass: "form-item-bottom" },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 14 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c("glVessel", {
                                                  attrs: { placeholder: "" },
                                                  model: {
                                                    value:
                                                      _vm.searchForm.vesselCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.searchForm,
                                                        "vesselCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "searchForm.vesselCode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "btn-primary",
                                                    staticStyle: {
                                                      display: "inline-block",
                                                    },
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.searchFormData()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "booking.bookingJapan.FilterByVessel"
                                                        )
                                                      ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 1 } }, [
                                  _vm._v(
                                    "\n                   \n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { staticClass: "form-item-bottom" },
                                      [
                                        _c(
                                          "el-row",
                                          { attrs: { gutter: 14 } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c("glRoute", {
                                                  attrs: { placeholder: "" },
                                                  model: {
                                                    value:
                                                      _vm.searchForm
                                                        .serviceLineCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.searchForm,
                                                        "serviceLineCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "searchForm.serviceLineCode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "btn-primary",
                                                    staticStyle: {
                                                      display: "inline-block",
                                                    },
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.searchFormData()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "booking.bookingJapan.FilterByLane"
                                                        )
                                                      ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "table-container-new",
                        staticStyle: { "margin-top": "20px" },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { "font-size": "12px" },
                            attrs: {
                              data: _vm.tableCostData,
                              size: "mini",
                              "highlight-current-row": "",
                              stripe: "",
                              border: "",
                            },
                            on: { "selection-change": _vm.hotTableSelect },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "NO",
                                index: _vm.indexMethod,
                                width: "50",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                width: "50",
                                align: "center",
                                selectable: _vm.checkSelectable,
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: "Space",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pol",
                                label: "POL",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "polEta",
                                label: "POL ETA",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.polEta.split(" ")[0]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" \n                    "),
                                        scope.row.polEta.split(" ")[1] === "Sat"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "limegreen",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.polEta.split(
                                                      " "
                                                    )[1]
                                                  )
                                                ),
                                              ]
                                            )
                                          : scope.row.polEta.split(" ")[1] ===
                                            "Sun"
                                          ? _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.polEta.split(
                                                      " "
                                                    )[1]
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.polEta.split(" ")[1]
                                                )
                                              ),
                                            ]),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "polEtd",
                                label: "POL ETD",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.polEtd.split(" ")[0]
                                            )
                                          ),
                                        ]),
                                        _vm._v(" \n                    "),
                                        scope.row.polEtd.split(" ")[1] === "Sat"
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "limegreen",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.polEtd.split(
                                                      " "
                                                    )[1]
                                                  )
                                                ),
                                              ]
                                            )
                                          : scope.row.polEtd.split(" ")[1] ===
                                            "Sun"
                                          ? _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.polEtd.split(
                                                      " "
                                                    )[1]
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.polEtd.split(" ")[1]
                                                )
                                              ),
                                            ]),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pod",
                                label: "POD",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "podEta",
                                label: "DEL ETA",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              staticStyle: { "word-break": "keep-all" },
                              attrs: {
                                prop: "routingInfo",
                                align: "left",
                                label: "ROUTE INFO",
                                "min-width": "20%",
                                sortable: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", {
                                        staticStyle: {
                                          "word-break": "keep-all!important",
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            scope.row.routingInfo
                                          ),
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sailingTime",
                                label: "SAILING TIME",
                                "min-width": "8%",
                                "show-overflow-tooltip": "true",
                                align: "center",
                                sortable: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: scope.column.label,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.column.label)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "terminalCode",
                                label: "POL Terminal",
                                "min-width": "20%",
                                "show-overflow-tooltip": "true",
                                align: "center",
                                sortable: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "serviceLineCode",
                                label: "POL Lane",
                                "min-width": "8%",
                                align: "center",
                                sortable: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-link",
                                        {
                                          staticStyle: { "font-size": "12px" },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleViewDetail(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                scope.row.serviceLineCode
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "block",
                            staticStyle: { "text-align": "right" },
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.listQuery.currentPage,
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.listQuery.pageSize,
                                layout: "total,sizes, prev, pager, next,jumper",
                                total: _vm.listQuery.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange,
                                "update:currentPage": function ($event) {
                                  return _vm.$set(
                                    _vm.listQuery,
                                    "currentPage",
                                    $event
                                  )
                                },
                                "update:current-page": function ($event) {
                                  return _vm.$set(
                                    _vm.listQuery,
                                    "currentPage",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userCenter.billConsigneeApplication.editDialogText"),
            visible: _vm.editDialog,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "billFormRef",
                      attrs: {
                        model: _vm.billForm,
                        rules: _vm.billRules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.portFormItem"
                            ),
                            prop: "portCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.billForm.portCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.billForm, "portCode", $$v)
                                },
                                expression: "billForm.portCode",
                              },
                            },
                            _vm._l(_vm.portOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.operationFormItem"
                            ),
                            prop: "companyName",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "companyName", $$v)
                              },
                              expression: "billForm.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.editFormDialog.operationFormItemCn"
                            ),
                            prop: "companyNameCn",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.companyNameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "companyNameCn", $$v)
                              },
                              expression: "billForm.companyNameCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t("userCenter.editFormDialog.USCI"),
                            prop: "usci",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.billForm.usci,
                              callback: function ($$v) {
                                _vm.$set(_vm.billForm, "usci", $$v)
                              },
                              expression: "billForm.usci",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-button-bottom" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveFormClick()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.saveButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "medium", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.editDialog = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("userCenter.editFormDialog.cancelButton")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("voyageDetails", {
        ref: "voyageDetails",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          voyagePlanJpVo: _vm.voyagePlanJpVo,
          visible: _vm.voyageDetailsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.voyageDetailsVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-info-area" }, [
      _c("div", { staticClass: "table-info-item" }, [
        _vm._v(
          "\n              Space Status  〇:Available  △:Tight  ×:Unacceptable\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }